export default "__VITE_PUBLIC_ASSET__cee86df6__"